import { useEffect, useRef } from 'react'

export type ShortcutMap = Record<string, (e: KeyboardEvent) => void>

const isTyping = (t: EventTarget | null) => {
  const el = t as HTMLElement | null
  if (!el) return false
  if (el.tagName === 'INPUT' && ['checkbox', 'radio', 'button', 'submit'].includes((el as HTMLInputElement).type)) return false
  return el.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(el.tagName) || el.getAttribute('role') === 'textbox'
}

/** Single-key Gmail-style shortcuts. Ignored while typing or when a modifier is held. */
export function useShortcuts(map: ShortcutMap, enabled: boolean) {
  const ref = useRef(map)
  ref.current = map
  useEffect(() => {
    if (!enabled) return
    const onKey = (e: KeyboardEvent) => {
      if (e.metaKey || e.ctrlKey || e.altKey || isTyping(e.target)) return
      const fn = ref.current[e.key]
      if (fn) { e.preventDefault(); fn(e) }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [enabled])
}
